import React from "react";

import { useFeatures } from "components/FeatureFlag";

import { getAllHubWorkflows } from "scenes/Hubly/components/Workspace/api/workflows";
import useNewHublyApp from "scenes/Hubly/useNewHublyApp";

async function resolveAllWorkflows(hub) {
  const toReduxObj = ({ multipleTimePerClient, ...w }) => {
    return { clients: [], options: { multipleTimePerClient }, ...w };
  };

  const { data } = await getAllHubWorkflows(hub);
  return [data.map(toReduxObj), true];
}

async function resolveEmpty() {
  return [[], false];
}

function formatClientWorkflowResponse(conditionLogicEnabled) {
  return ({ tasks, ...props }) => {
    return { ...props, tasks: conditionLogicEnabled ? [] : tasks };
  };
}

export function withWorkflowResolver(Component) {
  return (props) => {
    const { loadingConfig, newApp } = useNewHublyApp();
    const conditionLogicEnabled = useFeatures("conditional-logic");

    if (loadingConfig) return null;

    const resolve = newApp ? resolveAllWorkflows : resolveEmpty;
    return (
      <Component
        {...props}
        resolveAllWorkflows={resolve}
        formatCwfResponse={formatClientWorkflowResponse(conditionLogicEnabled)}
      />
    );
  };
}

export default withWorkflowResolver;
